import { Controller, useFormContext } from 'react-hook-form';

import { FinanceCheckbox } from '../../../../financeProviders/shared/FinanceCheckbox';
import { Text } from '../../../../../ToolkitV2/Text/Text';
import { Notification } from '../../../../../Toolkit/Notification/Notification';
import { ListNative } from '../../../../../ToolkitV2/ListNative/ListNative';

import { Spacer } from '../../../../../../helpers/genericStyles';

import { type Form } from '../../../../queries/schema/carFinance.schema';

const DataProtectionAndConsents = () => {
  const { control } = useFormContext<Form>();

  return (
    <>
      <Spacer marginBottom="M24" />
      <Text forwardedAs="h3" weight="bold" size="M16" color="GREY_DARKER">
        GDPR Applicant Declaration
      </Text>
      <Spacer marginBottom="M16" />
      <ListNative
        listType="ol"
        name="rights-with-respect-to-close-brothers"
        markerColour="GREY_DARKER"
      >
        <Text color="GREY_DARKER">
          I understand that, before I enter into the Loan, I have a right to
          know how Close Brothers Finance DAC (Close Brothers) will use my
          personal information. I have read, understand, and agree to the notice
          headed “Important – Use of your information” beneath this declaration.
        </Text>
        <Text color="GREY_DARKER">
          I understand that I have a right at any time to stop Close Brothers
          from contacting me, or giving my details to others, for these
          purposes. I can write to Close Brothers at Privacy, Close Brothers
          Finance DAC, Unit 18 Northwood House, Northwood Business Campus,
          Santry, Dublin 9 if I wish it to stop.
        </Text>
        <Text color="GREY_DARKER">
          I acknowledge and agree that any telephone calls and emails to do with
          my application may be recorded and monitored for information,
          regulatory and/or training purposes.
        </Text>
      </ListNative>
      <Spacer marginBottom="M16" />
      <Notification intent="INFO" alignItems="flex-start">
        NOTICE: From 30 June 2019, under the Credit Reporting Act 2013, lenders
        are required to provide personal and credit information for credit
        applications and credit agreements of €500 and above to the Central
        Credit Register. This information will be held on the Central Credit
        Register and may be used by other lenders when making decisions on your
        credit applications and credit agreements.
      </Notification>
      <Spacer marginBottom="M24" />
      <Text forwardedAs="h3" weight="bold" size="M16" color="GREY_DARKER">
        Important - Use of your Information
      </Text>
      <Spacer marginBottom="M16" />
      <ListNative
        name="close-brothers-rights-and-responsibilities"
        markerColour="GREY_DARKER"
      >
        <Text color="GREY_DARKER">
          To make credit decisions about you, and for money laundering
          prevention purposes and verification of your identity, Close Brothers
          will make searches about you at credit reference agencies who will
          supply it with credit information, and other agencies and/or archives
          of publicly held information such as the Electoral Register and
          registers of court judgments. Credit reference agencies will record
          details of the credit search made by Close Brothers whether or not
          your Application is successful and may use credit scoring methods or
          other automated decision making systems to assess your Application.
          Each search will be registered on your credit file(s) individually,
          and a number of searches within a short period may impact on your
          ability to obtain credit.
        </Text>
        <Text color="GREY_DARKER">
          Close Brothers may periodically submit information to credit reference
          agencies during the term of your Loan who in turn provide Close
          Brothers with information which Close Brothers may take into
          consideration when managing your Loan account or for analysis and
          statistical purposes.
        </Text>
        <Text color="GREY_DARKER">
          If you do not repay money owed to Close Brothers on time and in full,
          Close Brothers may inform credit reference agencies who will record
          the outstanding debt, and this may impact on your ability to obtain
          credit. Credit searches and other information which is provided to
          Close Brothers and/or credit reference agencies about you and those
          with whom you are linked financially may be used by Close Brothers and
          other companies to trace you to recover any outstanding debt owed to
          Close Brothers, and to manage your account.
        </Text>
        <Text color="GREY_DARKER">
          Close Brothers, members of the Close Brothers Group, and other
          companies may use any information it receives if decisions are made
          about you (or others at your addresses) on credit or credit related
          services or motor, household, credit, life or any other insurance
          facilities, and such information may also be used for tracing and
          claims assessment; and Close Brothers may check the validity of any
          identification document(s) you provide to prove your identity with the
          issuing authority of that document.
        </Text>
        <Text color="GREY_DARKER">
          If the Application is made in joint names and Close Brothers searches
          the files of a credit reference agency, an “association” will be
          created with the other person(s) named in the Application. Close
          Brothers or other lenders may take this association into account in
          future applications for credit or financial services. The association
          will remain between you until one of you successfully applies for
          “disassociation” with the credit reference agencies. Information held
          about you by credit reference agencies may be linked to records
          relating to other persons. For the purposes of your Application you
          may be financially linked as your Application will be assessed with
          reference to any “associated” records.
        </Text>
        <Text color="GREY_DARKER">
          Close Brothers may make enquiries of any person including current and
          previous lenders, employers, landlords, accountants, bankers, the
          Electoral Register, the Land Registry and Office of the Revenue
          Commissioners, in the processing of your Application and the
          administration of your account.
        </Text>
        <Text color="GREY_DARKER">
          Close Brothers may retain and hold the Information and all details and
          documents about you, including any information provided by any
          Intermediary, credit reference agency after your Loan is repaid or if
          your Application does not proceed, where Close Brothers has a duty to
          do, or for so long as is reasonable for legal or operational reasons.
        </Text>
        <Text color="GREY_DARKER">
          Close Brothers may share information about you and the conduct and
          operation of your Loan account during the term of your Loan and after
          your Loan is repaid (or if your Application does not proceed), where
          Close Brothers has a duty to do so, or (to the extent that is
          proportionate) for the purpose of its own or a third party’s
          legitimate interests, to Close Brothers’ regulators, other Close
          Brothers group companies, any company providing insurance services or
          other products in connection with the Loan, with third parties who
          provide services to us which require the processing of your personal
          information, any intended guarantor, investors, funders or their
          advisors, potential investors or funders and rating agencies.
        </Text>
      </ListNative>
      <Spacer marginBottom="M16" />
      <Text color="GREY_DARKER">
        Please telephone us on <a href="tel:016448900">01 644 8900</a> if you
        want to have details of those credit reference agencies (CRA“s) from
        whom we obtain and to whom we pass information about you. You have a
        legal right to these details. You have a right to receive a copy of the
        information we hold about you if you apply to us in writing.
      </Text>
      <Spacer marginBottom="M16" />
      <Text color="GREY_DARKER">
        The Central Credit Register (CCR) is the Central Bank of Ireland of New
        Wapping Street, North Wall Quay, Dublin 1 ({/* */}
        <a href="mailto:dataprotection@centralbank.ie">
          dataprotection@centralbank.ie
        </a>
        {/* */}) shall process the personal data identified in this proposal
        form. The legal basis upon which CRA relies to process this personal
        data is its Legitimate interests. (GDPR Article 6 (f)), namely for
        promoting greater financial stability by supporting a full and accurate
        assessment of loan applications, aiding in the avoidance of
        over-indebtedness, assisting in lowering the cost of credit, complying
        with and supporting compliance with legal and regulatory requirements,
        enabling more consistent, faster decision-making in the provision of
        credit and assisting in fraud prevention.
      </Text>
      <Spacer marginBottom="M16" />
      <Text color="GREY_DARKER">
        Please review The CCR's Fair Processing Notice which is available at:{' '}
        <a
          href="https://www.centralcreditregister.ie/borrower-area/data-protection/"
          target="_blank"
        >
          https://www.centralcreditregister.ie/borrower-area/data-protection/
        </a>
        {/* */}. It documents who they both are, what they do, details of their
        Data Protection Officer, how they get the data, why they take it, what
        personal data they hold, what they do with it, how long they retain it,
        who they share it with, what entitles them to process the data
        (legitimate interests), what happens if your data is inaccurate and your
        rights i.e. right to information, right of access, right to complain,
        right to object, right to restrict, right to request erasure and right
        to request correction of your personal information.
      </Text>
      <Spacer marginBottom="M16" />
      <Controller
        name="consent.dataConsent"
        control={control}
        render={({
          field: { onChange, name, ref, value, onBlur },
          fieldState,
        }) => (
          <FinanceCheckbox
            name={name}
            ref={ref}
            onChange={onChange}
            onBlur={onBlur}
            checked={value}
            {...fieldState}
            label={
              <Text weight="bold" color="GREY_DARKER">
                I agree with the above terms and conditions and consent to the
                details of my finance application being submitted to DoneDeal
                and Close Brothers.
              </Text>
            }
          />
        )}
      />
    </>
  );
};

export { DataProtectionAndConsents };
